import { render, staticRenderFns } from "./StorageSelectSection.vue?vue&type=template&id=196450f4&scoped=true&lang=html&"
import script from "./StorageSelectSection.vue?vue&type=script&lang=ts&"
export * from "./StorageSelectSection.vue?vue&type=script&lang=ts&"
import style0 from "./StorageSelectSection.vue?vue&type=style&index=0&id=196450f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196450f4",
  null
  
)

export default component.exports